import axios from "axios";
import ServiceStorage from "./../services/service.storage";

import BasketStorage from "./../../ui/views/Basket/Component/BasketStorage";
import has from "lodash/has";
import isEmpty from "lodash/isEmpty";
import isObject from "lodash/isObject";
import { toast } from "react-toastify";

const env = process.env;
const ServiceApi = axios;
ServiceApi.defaults.timeout = 30000;
ServiceApi.defaults.baseURL = env.REACT_APP_API_URL;
const prtectedApiUrl = process.env.REACT_APP_Protected_API_URL;
// ServiceApi.defaults.baseURL = 'https://localhost:9001';
ServiceApi.defaults.headers.common["Authorization"] = "AUTH TOKEN";

ServiceApi.interceptors.request.use(
  async (config) => {
    //  دریافت دوباره توکن از استورج برای هر درخواست
    ServiceApi.setToken();
    axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*,https://www.tafrihan.com";
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

ServiceApi.interceptors.response.use(
  (response) => {
    if (
      isEmpty(response) &&
      isEmpty(response?.headers["token-expired"]) &&
      response.headers["token-expired"] === "true"
    ) {
      console.log("token-expired response", response);
      ServiceApi.logout();
    }

    if (
      !isEmpty(response) &&
      !isEmpty(response.data) &&
      has(response.data, "isAuth") &&
      !response.data.isAuth
    ) {
      // ServiceApi.logout();
    }
    return response.data;
  },
  async (error) => {
    if (error == null) console.log("null");
    else console.log("error x ", error);

    const originalConfig = error.config;
    // if (originalConfig.url !== "/auth/signin" && err.response) {
    // Access Token was expired
    //console.log("A1");
    if (
      (error?.response?.status === 401 || error?.response?.status === 403) &&
      !originalConfig._retry
    ) {
      originalConfig._retry = true;
      try {
        const rs = await ServiceApi.post(
          `${prtectedApiUrl}/api/Account/RefreshToken`,
          {
            //refreshToken: TokenService.getLocalRefreshToken(),
            //accessToken: ServiceStorage.getAccessToken(),
            refreshToken: ServiceStorage.getRefreshToken(),
          }
        );
        if (rs.succeeded) {
          ServiceStorage.setToken(rs.data.accessToken, rs.data.refreshToken);
          originalConfig.headers.Authorization =
            "Bearer " + rs.data.accessToken;
          axios.defaults.headers.common["Authorization"] =
            "Bearer " + rs.data.accessToken;
          //TokenService.updateLocalAccessToken(accessToken);
        } else {
          // login page
          ServiceApi.logout();
          return (window.location.href = "/login");
        }
        return ServiceApi(originalConfig);
      } catch (_error) {
        return Promise.reject(_error);
      }
    }
    if (error) {
      if (
        error.response != undefined &&
        error.response.status != undefined &&
        [401, 403].includes(error.response.status)
      ) {
        //خروج از حساب کاربری
        //ServiceApi.logout();

        // window.location.replace(`#${ConfigLink.accountLogin}`);
        // console.error(`#${ConfigLink.accountLogin}`);
        console.error("should redirect to login");
        // Swal.fire({
        //   position: 'bottom-end',
        //   reverseButtons: true,
        //   icon: 'error',
        //   title: error.response.data.Message,
        //   showConfirmButton: false,
        //   timer: 5000
        // });
        //  //باز کردن لاگین
        // let history = useHistory();
        // let path = '/login';
        //history.push(path);
      }
    }
    return Promise.reject(ServiceApi.getErrorText(error));

    //return Promise.reject(error);
  }
);

ServiceApi.setToken = () => {
  const access_token = ServiceStorage.getAccessToken();
  if (access_token) {
    axios.defaults.headers.common["Authorization"] = "Bearer " + access_token;
  } else {
    axios.defaults.headers.common["Authorization"] = "";
    delete axios.defaults.headers.common["Authorization"];
  }
};

ServiceApi.logout = () => {
  // const ctx = useContext(ContextApp);
  // سبد خرید نباید پاک شود پس
  //دریافت سبد خرید
  const Basket = BasketStorage.getBasket();

  ServiceStorage.clearToken();
  ServiceApi.setToken();

  // قرار دادن سبد خرید دریافتی در استوریج
  BasketStorage.setBasket(Basket);

  // ctx.setIsAuth(false);
};

ServiceApi.getErrorText = (ex) => {
  console.log("ex333333=", ex);
  let errorText = "An unknown error occurred.";

  if (
    ex === undefined ||
    ex.response === undefined ||
    ex.response.status === undefined
  ) {
    //errorText = errorText;
    errorText = "Can not connect to server.";
  } else if (ex.response.status === 403) {
    errorText = "You have not required role to do this.";
  } else if (
    ex.response.data !== undefined &&
    ex.response.data.error_description !== undefined
  ) {
    errorText = ex.response.data.error_description;
  } else if (
    ex.response.data !== undefined &&
    ex.response.data.message !== undefined
  ) {
    console.log("errorText ex.response.data", ex.response.data);
    errorText = ex.response.data.message;
  }
  if (
    ex === undefined ||
    ex.response === undefined ||
    ex.response.status === undefined
  ) {
    //errorText = errorText;
    errorText = "Can not connect to server.";
  } else if ([400].includes(ex.response.status)) {
    // نمایش خطا ها روی صفحه به کاربر
    //validation Error
    let message = "";
    //console.log("ex.response.data", ex.response.data);
    //console.log("ex.response.data.errors", ex.response.data.errors);
    //console.log("ex.response.data.Message", ex.response.data.Message);
    if (ex.response.data.Message)
      ex.response.data.message = ex.response.data.Message;
    if (ex.response.data.message) {
      message = message + ex.response.data.message;
    }
    if (ex.response.data.Errors)
      ex.response.data.errors = ex.response.data.Errors;
    if (ex.response.data.errors) {
      if (isObject(ex.response.data.errors)) {
        Object.entries(ex.response.data.errors).map(([key, value]) => {
          message = message + value;
        });
      } else {
        ex.response.data.errors.map((itemData, index) => {
          message = message + itemData;
        });
      }
    }
    errorText = "error 400";
    toast.error(message, {
      duration: 10000,
      position: "top-right",
    });
    // Swal.fire({
    //   position: "bottom-end",
    //   reverseButtons: true,
    //   icon: "error",
    //   title: message,
    //   showConfirmButton: false,
    //   timer: 5000,
    // });
  } else if ([500].includes(ex.response.status)) {
    //  تمامی پارامترهای ورودی پاس داده نشده اند
    // و یا خطایی رخ داده در سرور
    // console.log("errorText = ", ex);
    // console.log("errorText =ex.response ", ex.response);
    // console.log("errorText = ex.response.data", ex.response.data);
    // console.log("errorText =ex.response.Message ", ex.response.data.Message);
    errorText = "error 500";
    toast.error("متاسفانه سایت با خطا مواجه شد", {
      duration: 10000,
      position: "top-right",
    });
    // Swal.fire({
    //   position: "bottom-end",
    //   reverseButtons: true,
    //   icon: "error",
    //   title: "متاسفانه سایت با خطا مواجه شد",
    //   showConfirmButton: false,
    //   timer: 5000,
    // });
  }

  if (
    errorText &&
    typeof errorText === "object" &&
    errorText.constructor === Array
  ) {
    errorText = errorText.join("\n");
  }
  console.log("errorText = ", errorText);

  return errorText;
};

ServiceApi.hasToken = () => {
  const access_token = ServiceStorage.getAccessToken();

  if (access_token) {
    return true;
  } else {
    return false;
  }
};

ServiceApi.setToken();

export default ServiceApi;
